import React from 'react'

import { Button, SectionSubtitle } from '../..'
import { Spacer } from '../../global'
import Modal from '../Modal'
import { CenteredContainer } from '../styles'

const DeleteUserModal = ({ resetUsers }: { resetUsers: () => void }) => {
  return (
    <Modal onClose={resetUsers}>
      <Spacer height={30} />
      <SectionSubtitle fontSize={16} fontWeight={500} textAlign="center">
        <p>
          Usuario eliminado de la base de datos. <br />
          <br />
          Recuerda eliminar manualmente el email en la <br />
          <span style={{ fontWeight: 600 }}>
            Consola de Autenticación de Firebase
          </span>
        </p>
      </SectionSubtitle>
      <Spacer height={30} />
      <CenteredContainer>
        <Button
          className="dark-grey"
          fontSize={15}
          onClick={resetUsers}
          label="Cerrar"
        />
      </CenteredContainer>
    </Modal>
  )
}

export default DeleteUserModal
